/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function FileDownload({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M5.076 9.576a.6.6 0 0 1 .848 0L7.4 11.052V5.5a.6.6 0 0 1 1.2 0v5.552l1.476-1.476a.6.6 0 1 1 .848.849l-2.5 2.5a.598.598 0 0 1-.848 0l-2.5-2.5a.6.6 0 0 1 0-.849Z" /><path fill="currentColor" fillRule="evenodd" d="M1.4 3A2.6 2.6 0 0 1 4 .4h5.172a2.6 2.6 0 0 1 1.838.762L13.84 3.99A2.6 2.6 0 0 1 14.6 5.83V13a2.6 2.6 0 0 1-2.6 2.6H4A2.6 2.6 0 0 1 1.4 13V3ZM4 1.6A1.4 1.4 0 0 0 2.6 3v10A1.4 1.4 0 0 0 4 14.4h8a1.4 1.4 0 0 0 1.4-1.4V5.83a1.4 1.4 0 0 0-.41-.99L10.161 2.01a1.4 1.4 0 0 0-.99-.41H4Z" clipRule="evenodd" /></svg>;
}
;